import { supabase } from '../../config/supabase';

export const getMonthlyInvoiceAssignments = async (
  companyId,
  quoteType,
  { monthStart, monthEnd }
) => {
  const { data, error } = await supabase
    .from("job_quotes")
    .select(`
      *,
      jobs!inner (
        id,
        unique_id,
        company_id,
        customer_name,
        customer_address,
        deleted,
        is_cancelled
      )
    `)
    .eq("jobs.company_id", companyId)
    .eq("jobs.deleted", false)
    .eq("quote_type", quoteType)
    .eq("is_required", true)
    // Playground-pinned quotes have no real schedule date, but expected_finish_date
    // is often left set, so they'd otherwise slip in through the finish-date fallback
    // below. eq(false) alone would drop legitimate NULL rows (NULL = true is NULL,
    // not false), so both false and NULL are accepted explicitly for each column.
    .or(
      "and(quote_playground.is.null,delivery_playground.is.null)," +
      "and(quote_playground.is.null,delivery_playground.eq.false)," +
      "and(quote_playground.eq.false,delivery_playground.is.null)," +
      "and(quote_playground.eq.false,delivery_playground.eq.false)"
    )
    .or(
      `and(expected_delivery_date.gte.${monthStart},expected_delivery_date.lt.${monthEnd}),and(expected_delivery_date.is.null,expected_finish_date.gte.${monthStart},expected_finish_date.lt.${monthEnd})`
    )
    .order("expected_delivery_date", { ascending: true, nullsFirst: false })
    .order("expected_finish_date", { ascending: true, nullsFirst: false });

  if (error) return { data: [], error };


  return {
    data: (data || []).map((quote) => ({
      id: quote.jobs.id,
      unique_id: quote.jobs.unique_id,
      customer_name: quote.jobs.customer_name,
      customer_address: quote.jobs.customer_address,
      quote_info: {
        ...quote,
        is_cancelled: quote?.jobs?.is_cancelled || false
      },
      is_cancelled: quote?.jobs.is_cancelled || false
    })),
    error: null,
  };
};